import { FormEvent, useState } from "react";
import FormWrapper from "../../components/forms/FormWrapper";
import useMultistepForm from "../../hooks/useMultistepForm";
import { useMutation, useQuery } from "@apollo/client";
import { FieldData } from "../../hooks/useForm";
import { GET_CHKLIST_ITEMS, SUBMIT_INSPECTION_REQUEST } from "../../graphql/queries";
import { FieldType, FormField } from "../../helpers/types";
import { RecordFieldsConfig } from "./config";
import MantineModal from "../../components/modal/MantineModal";
import InspectInitForm from "./InspectInitForm";
import { Text } from "@mantine/core";
import { getFuzzyDate } from "../../helpers/dates";

function InspectionRecordForm({ onComplete, open }: { open: boolean; onComplete: Function }) {
   const { data, loading, error } = useQuery(GET_CHKLIST_ITEMS, {
      fetchPolicy: "network-only",
   });
   const [inspectionId, setInspectionId] = useState<number>()
   const [inspectionDate, setInspectionDate] = useState<any>()
   const [formData, setFormData] = useState(new Map());
   const [wasDefects, setWasDefects] = useState<string[]>([]);
   const [submitInspectionReq, { loading: submitLoading }] = useMutation(SUBMIT_INSPECTION_REQUEST);
   function updateFormData({ name, value }: FieldData) {
      const isChecklist = name.match(/(item-[\d])+/g);  // Match all checklist items
      if (isChecklist && reInspect && wasDefects.includes(name)) {
         if (["Partial"].includes(value)) {
            console.error("You can not update to partial: ", { name, value })
            return
         }
      }
      setFormData((prev) => {
         return new Map([...prev, [name, value]]);
      });
   }

   const vehicleReg = formData?.get('vehicleReg')
   const reInspect = inspectionId ? true : false
   console.log({ vehicleReg, inspectionId, reInspect })

   let cfg = RecordFieldsConfig(updateFormData, formData, false, reInspect);

   const onSubmit = (ev: FormEvent) => {
      ev.preventDefault();
      console.log("onSubmit?")
      if (isLastStep) {
         const arr = Array.from(formData, function (entry) {
            return {
               name: entry[0],
               value: entry[1],
               type: Array.isArray(entry[1]) ? FieldType.MULTIPLE : FieldType.SINGLE,
            };
         });

         let items = arr.filter((f) => f.name.split("-").length === 2);
         let inspection: any = {};
         cfg.introFields.forEach((f) => {
            inspection[f.name] = formData.get(f.name);
         });
         cfg.finalFields.forEach((f) => {
            inspection[f.name] = formData.get(f.name);
         });

         if (inspectionId) {
            inspection.id = inspectionId
         }

         const submitData = items.map((i) => {
            let parts = i.name.split("-");
            let iFiles = arr.filter((f) => `${f.name}`.endsWith(`${parts[1]}-image`)).map((f) => f.value);
            let rName = `item-${parts[1]}-reason`;
            let remarks = arr.find((f) => {
               return f.name === rName;
            })?.value;
            console.log({ remarks, iFiles });

            return {
               itemId: parseInt(parts[1]),
               optionValue: i.value,
               attachments: iFiles,
               remarks: remarks,
            };
         });
         console.log({ submitData });
         submitInspectionReq({
            variables: {
               data: {
                  items: submitData,
                  remarks: "General comment",
                  inspection,
               },
            },
         })
            .then((res) => {
               if (res.data) {
                  onComplete();
               } else {
                  console.error("Error: ", res.errors);
               }
            })
            .catch(console.error);
      } else {
         next();
      }
   };
   let steps: any[] = [
      {
         fields: cfg.introFields,
      },
   ];
   if (data && !loading) {
      let max = 5;
      let step: any;
      data.getAllItems.forEach((i: any, idx: number) => {
         if (idx === 0 || idx % max === 0) {
            if (step) {
               steps.push(step);
            }
            step = {};
         }
         step.fields = step.fields || [];
         let name = `item-${i.id}`
         let value = formData?.get(name)
         let wasDefect = wasDefects.includes(name)
         console.log({ name: i.name, wasDefect, value })
         let field: FormField = {
            name: name,
            label: i.name,
            cols: 2,
            type: "radio",
            onChange: updateFormData,
            formData: formData,
            options: {
               required: true,
            },
            choices: [
               { label: "Compliant", value: "Compliant" },
               { label: "Partially Compliant", value: "Partial" },
               { label: "Flawed", value: "Flawed" },
            ],
            extras: {
               styles: {
                  backgroundColor: wasDefect ? (!["Compliant"].includes(value) ? "#FFDDDD" : "#DDFFDD") : undefined
               }
            },
            conditions: [
               {
                  allow: (value: any) => ["Flawed", "Partial"].includes(value),
                  fields: [
                     {
                        label: 'Reason',
                        name: `item-${i.id}-reason`,
                        onChange: ({ name, value }: any) => {
                           updateFormData({ name, value });
                        },
                        formData: data,
                        options: {
                           required: true,
                        }
                     }
                  ],

               },
               {
                  allow: (value: any) => value === "Flawed",
                  fields: [{
                     label: 'Provide image',
                     name: `item-${i.id}-image`,
                     onChange: ({ name, value }: any) => {
                        updateFormData({ name, value });
                     },
                     type: "file",
                     formData: data,
                     isMulti: true,
                     options: {
                        required: true,
                        accept: "image/*"
                     }
                  }],
               },
            ],
         }
         step.fields.push(field);
      });
      if (step) {
         steps.push(step);
      }
   }
   steps.push({
      fields: cfg.finalFields,
   });
   const { numberOfSteps, currentStepIndex, step, next, back, isFirstStep, isLastStep } = useMultistepForm(
      steps.map((s, idx_) => (
         <FormWrapper key={idx_} fields={s.fields} updateFormData={updateFormData} formData={formData} />
      ))
   );

   console.log({ data })

   return (
      <MantineModal
         title="Capture Inspection"
         done={() => onComplete()}
         open={open}
      >
         {vehicleReg ? <form onSubmit={onSubmit} autoComplete='nope'>
            {reInspect ?
               <Text bg={"orange"} p={2} c={"white"}>Re-Inspection - Inspected {getFuzzyDate(new Date(inspectionDate))}</Text>
               : <Text bg={"green"} p={2} c={"white"}>New Inspection</Text>
            }
            {step}
            {step && (
               <div className='flex justify-between items-center gap-4 border-t mt-2'>
                  <p>
                     {currentStepIndex + 1} / {numberOfSteps}
                  </p>
                  <div>
                     <button onClick={() => setFormData(new Map())} type='button' className='border rounded px-5 py-1 btn-sm text-orange-500'>
                        Restart Inspection
                     </button>
                  </div>
                  <div className='form-controls flex gap-3 justify-end py-2 text-lg'>
                     <div className="flex gap-1">
                        {!isFirstStep && (
                           <button className='border rounded px-5 py-1 text-blue-500' onClick={back} type='button'>
                              Back
                           </button>
                        )}
                        {submitLoading ? (
                           <button type='button' className='border rounded px-5 py-1 bg-primary text-white btn-sm'>
                              Submiting ...
                           </button>
                        ) : (
                           <button type='submit' className='border rounded px-5 py-1 bg-primary text-white btn-sm'>
                              {isLastStep ? "Submit" : "Next"}
                           </button>
                        )}
                     </div>
                  </div>
               </div>
            )}
         </form> : <InspectInitForm proceed={(data, inspectionId, wasDefects, inspection) => {
            console.log({ data, inspectionId, wasDefects, inspection })
            setInspectionId(inspectionId)
            if (inspection?.createdAt) setInspectionDate(inspection.createdAt)
            setWasDefects(prev => {
               return wasDefects ? [...wasDefects] : []
            })
            setFormData(prev => {
               return new Map([...data])
            })
         }} />}
      </MantineModal>
   );
}

export default InspectionRecordForm;
